import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import { Spin } from "antd";

import { doSignIn, doSignUp } from "../stores/thunk";
import { setRedirectUrl } from "../stores/slice";
import { hexToRgbWithOpacity } from "../../../utils/color";

export default Component => {
  class Container extends React.Component {
    render() {
      const { auth, isFetchingDetailCode } = this.props;
      if (isFetchingDetailCode) return <Spin style={{ paddingTop: 100, width: "100%" }} />;

      if (window.location.origin.includes("nordicrouting.se")) {
        const primaryColor = "#009CFF";
        const primaryColorOpacityRgb = hexToRgbWithOpacity(primaryColor, 0.24);
        document.documentElement.style.setProperty("--primary-color", primaryColor);
        document.documentElement.style.setProperty("--primary-color-opacity", primaryColorOpacityRgb);
      }

      let redirectUrl = auth.redirectUrl;
      const currentRoutePlan = Cookies.get(`currentRoutePlan-${auth.userData?.sub}`);

      if (!!currentRoutePlan && (!redirectUrl || redirectUrl === "/")) {
        const routePlanT = JSON.parse(currentRoutePlan);
        redirectUrl = `/route-plans/${routePlanT._id}`;
      }

      return auth.authenticated ? <Redirect to={redirectUrl} /> : <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      auth: state.auth,
      detailCode: state.group.detailCode,
      isFetchingDetailCode: state.group.isFetching,
      statusDetailCode: state.group.status,
    };
  }
  return connect(mapStateToProps, { doSignIn, doSignUp, setRedirectUrl })(Container);
};
